import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { produce } from "../../../../../../../libs/immer";
import { EStatus } from "../../../../../../../constants";
import { withSmsProcessingLogic } from "./utils.domain";
import { closeStatusPopupUseCase } from "../../RequestStatus/logic/closePopup.case";
export var submitSmsCodeUseCase = function submitSmsCodeUseCase(_ref) {
  var submitPayment = _ref.submitPayment;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            closeStatusPopupUseCase(setState);
            return _context.abrupt("return", withSmsProcessingLogic(setState)(submitPayment(getState, setState)).then(function (result) {
              setState(produce(function (draft) {
                if (!result) return;
                draft.scenario = undefined;
                draft.statusPopup = result;
              }));
            }).catch(function () {
              setState(produce(function (draft) {
                draft.scenario = undefined;
                draft.statusPopup = EStatus.Error;
              }));
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};